import React, { Suspense } from 'react';

import { Skeleton } from 'antd';
import classnames from 'classnames';

import { GridStyleLayout } from 'common/components';
import { WIDTH_ROW_SKELETION } from 'static/Constants';

const SuspendLayout = (props) => {
  const { children, ...restProps } = props;
  return (
    <Suspense
      fallback={
        <GridStyleLayout className='main__layout' rows='0 auto auto 1fr'>
          <div
            className={classnames('main__title', {
              'main__title--visible': true,
            })}
          >
            <div className='main__title-btn' />
          </div>

          <div
            className={classnames('ribbon', 'main__ribbon')}
            data-ribbon-ref
            style={{
              padding: '4px',
              lineHeight: 0,
            }}
          ></div>

          <div
            className={classnames('main__content')}
            style={{
              height: '100%',
              position: 'relative',
              padding: 4,
            }}
          >
            {/* same Skeleton as the grid pages so chunk loading -> data loading looks continuous */}
            <Skeleton
              active
              paragraph={{
                rows: Math.ceil(window.innerWidth / WIDTH_ROW_SKELETION),
              }}
            />
          </div>
        </GridStyleLayout>
      }
      {...restProps}
    >
      {children}
    </Suspense>
  );
};

export default SuspendLayout;
